import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import {
  LeftSide, ModalBody, ModalContent, ModalHeader, TextContainer, TitleBox,
} from './GlobalAssistencaStradaleModal.styles';
import { ProfessionInfoModalStyles } from './ProfessionInfoModal.styles';
import infoIcon from '../../../../assets/redesign_icons/info-icon.svg';

function RcFamigliaNobisModal({ setShowModal }) {
  const closeModal = () => {
    setShowModal(false);
  };
  return (
    <ProfessionInfoModalStyles>
      <ModalBody>
        <ModalHeader>
          <LeftSide>
            <FontAwesomeIcon
              fontSize={34}
              icon={faTimes}
              cursor="pointer"
              onClick={() => closeModal()}
            />
            <TextContainer>
              <TitleBox>
                <img src={infoIcon} alt="" />
                <h3>Informazione</h3>
              </TitleBox>
              <p>Qui puoi controllare le informazioni su questa offerta.</p>
            </TextContainer>
          </LeftSide>

        </ModalHeader>
        <ModalContent>

          <p className="mt-3">
            Copre l'Assicurato e la sua famiglia nel caso ricevano richieste di risarcimento per i danni involontariamente cagionati a terzi per morte, lesioni personali e danneggiamenti a cose e animali, in conseguenza di un fatto accidentale verificatosi in relazione alla vita privata del proprio nucleo familiare, ivi compresi i rischi devivanti:

          </p>
          <p className="mt-3">- da propietà e/o conduzione del fabbricato di abitazione</p>
          <p>- da conduzione della dimora di villeggiatura</p>
          <p>- da propietà ed uso di imbarcazioni senza motore di lunghezza non superiore a 6 metri e wind-surf</p>
          <p>- da propietà ed uso di velocipedi, di cavalli da sella, di animali domestici</p>
          <p>- da pratica di sport comuni, escluse le competizioni di carattere agonistico</p>

          <p className="mt-4">La garanzia è inoltre estesa alla Responsabilità Civile:</p>

          <p className="mt-3">- per danni derivanti dall'incendio di veicoli a motore ad uso privato, comprese le roulottes e i carrelli da campeggio, di propietà dell'Assicurato e/o dei familiari conviventi e posti in sosta se aree private</p>

          <p>- delle persone non conviventi per fatto dei figli minori dell'Assicurato a loto temporaneamente affidati in custodia, purchè tale custodia non costituisca attività professionale</p>

          <p>- verso baby-sitters, ragazze alla pari per infortuni da esse sofferti in conseguenza di reato colposo, perseguibile d'ufficio giudizialmente accertato</p>

          <p>- per fatto colposo degli addetti ai servizi domestici, inerente lo svolgimento delle proprie mansioni, compresa la Responsabilità Civile dei medesimi </p>

          <p className="mt-5">La garanzia per danni a cose è prestata con una franchigia assoluta di 100 euro per ciascun sinistro.</p>

        </ModalContent>

      </ModalBody>
    </ProfessionInfoModalStyles>
  );
}

export default RcFamigliaNobisModal;
